import React, {useCallback, useState, useEffect, useRef} from 'react';
import {Button, Radio, InputNumber, Image, Space} from 'antd'
import {CloseOutlined} from '@ant-design/icons'
import AvatarUploader, {FileUploader} from "../../components/Uploader";

export default function ({onSave, onCancel, data={}}) {

    const [typeCode, setTypeCode] = useState(1)
    const [imgList, setImgList] = useState([])
    const [filePath, setFilePath] = useState()
    const [minutes, setMinutes] = useState(0)
    const [seconds, setSeconds] = useState(0)
    const videoRef = useRef()

    useEffect(()=>{
        if (data.courseId) {
            setTypeCode(data.typeCode||1)
            if (data.typeCode === 1) {
                setFilePath(data.filePath)
                setMinutes(Math.floor(data.totalNumber/60))
                setSeconds(data.totalNumber%60)
            } else {
                setImgList(data.filePath?data.filePath.split('|'):[])
            }
        } else {
            setTypeCode(1)
            setFilePath()
            setMinutes()
            setSeconds()
            setImgList([])
        }
    },[data.courseId])

    const onTypeChange = useCallback((e) => {
        setTypeCode(e.target.value)
    })
    const onImgUploader = useCallback(url => {
        setImgList([url, ...imgList])
    })
    const onDeleteImg = useCallback(i => {
        imgList.splice(i, 1)
        setImgList([...imgList])
    })

    const onFileUploader = useCallback(url => {
        setFilePath(url)
        loadDuration()
    })

    const loadDuration = useCallback(()=>{
        let inst = setInterval(() => {
            if (videoRef.current && videoRef.current.duration) {
                clearInterval(inst)
                let duration = Math.ceil(videoRef.current.duration)
                setMinutes(Math.floor(duration / 60))
                setSeconds(duration % 60)
            }
        }, 1000)
    })

    const save = useCallback(() => {
        onSave && onSave({
            typeCode,
            filePaths: typeCode === 1 ? filePath?[filePath]:[] : imgList,
            totalNumber: typeCode === 1 ? minutes * 60 + seconds : imgList.length
        })
    })

    return (<div className="white-bg mgt12 pdv40 pdh32" style={{minWidth: 800, maxWidth: 1200}}>
        <div className="mgt20">
            <span className="required bold">课程形式：</span>
            <Radio.Group value={typeCode} onChange={onTypeChange}>
                <Radio.Button value={1}>视频</Radio.Button>
                <Radio.Button value={2}>图片</Radio.Button>
            </Radio.Group>
        </div>
        {typeCode === 1 && <div className="pdv12 mgt14">
            <div className="required bold">上传课程： <FileUploader onResult={onFileUploader}/></div>
            <div className="gray mgt12" style={{paddingLeft: 72}}>支持扩展名：仅支持mp4格式</div>
            {filePath &&
                <div className="relative white-light-bg mgt12" style={{marginLeft: 72, width: 200, height: 120}}>
                    <video src={filePath}
                           ref={videoRef}
                           controls
                           preload="auto"
                           style={{width: 200, height: 120}}
                           poster={filePath+"?spm=qipa250&x-oss-process=video/snapshot,t_7000,f_jpg,w_800,h_450,m_fast"}
                    />
                    <CloseOutlined className="absolute cursor" onClick={() => setFilePath()}
                                   style={{top: 0, right: 0}}/>
                </div>}
            <div className="flexbox align-center mgt20">
                <span className="bold required">视频时长：</span>
                <InputNumber
                    type="number"
                    min={0}
                    max={200}
                    value={minutes}
                    onChange={(val) => setMinutes(val)}
                    style={{width: 80, height: 32}}/>
                <span className="mgl6 mgr4">分</span>
                <InputNumber
                    type="number"
                    min={0}
                    max={59}
                    value={seconds}
                    onChange={(val) => setSeconds(val)}
                    style={{width: 80, height: 32}}/>
                <span className="mgl6">秒</span>
            </div>
        </div>}
        {typeCode === 2 && <div className="pdv12 mgt20">
            <div className="mgb8 required bold">上传课程：</div>
            <AvatarUploader onResult={onImgUploader}/>
            <div className="gray">支持jpg、png、jpeg格式，尺寸为600px *600px</div>
            <div className="mgt20">
                {imgList && imgList.map((imgPath, i) => <div className="relative mgr12 mgb12 inline-block" key={imgPath}>
                    <Image
                        className="border-radius"
                        width={128}
                        height={80}
                        src={imgPath}
                    />
                    <CloseOutlined className="absolute cursor" onClick={() => onDeleteImg(i)}
                                   style={{top: 6, right: 6}}/>
                </div>)}
            </div>
        </div>}
        <div className="text-right mgt30">
            <Space>
                <Button onClick={onCancel}>取消</Button>
                <Button type="primary" onClick={save}>保存</Button>
            </Space>
        </div>
    </div>)
}
